export const SUPPORTED_LANGUAGES = ["nl", "fr", "en"];

// NOTE: Any webshop link can carry ?lng=nl|fr|en to open the site in that language
export const getUrlLanguage = (search = window.location.search) => {
  const lng = new URLSearchParams(search)
    .get("lng")
    ?.slice(0, 2)
    .toLowerCase();
  return SUPPORTED_LANGUAGES.includes(lng) ? lng : null;
};

export const removeUrlLanguage = (search) => {
  const params = new URLSearchParams(search);
  params.delete("lng");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};
